import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/styles';

const CustomizedSwitch = withStyles(() => ({
  root: {
    width: 54,
    height: 28,
    padding: 0,
    display: 'flex',
    border: 'none',
    borderRadius: 28 / 2,
    boxShadow: '0px 4px 4px 0px var(--color-gray-shadow)',
  },
  switchBase: {
    padding: 0,
    color: 'var(--color-white)',
    '&$checked': {
      transform: 'translateX(26px)',
      color: 'var(--color-white)',
      '& + $track': {
        opacity: 1,
        backgroundColor: 'var(--color-main-orange)',
        borderColor: 'var(--color-main-orange)',
      },
    },
  },
  thumb: {
    margin: 1,
    padding: 0,
    width: 26,
    height: 26,
    boxShadow:
      'inset 0px 4px 4px 0px var(--color-gray-shadow), 0px 4px 4px 0px var(--color-gray-shadow)',
  },
  track: {
    height: 28 - 2,
    width: 54,
    borderRadius: 28 / 2,
    opacity: 1,
    backgroundColor: 'var(--color-white)',
    border: '1px solid var(--color-blue-slider)',
  },
  checked: {},
}))(Switch);

function SliderFormField({ checked, onChange }) {
  return (
    <div>
      <CustomizedSwitch checked={checked} onChange={onChange} />
    </div>
  );
}

export default SliderFormField;
